import { CodeInput } from '@components/App/Auth/VerifyEmail/components/CodeInput/CodeInput'
import { Modal } from '@lib/components'
import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectIsLoading } from '@/store'
import { AccountActions, selectOtp } from '@/store/reducers/account'
import type { ModalProps } from '@/types'
import css from './styles.module.css'

const CODE_LENGTH = 6

export const ChangeEmailOtp: React.FC<ModalProps> = ({ onClose }) => {
  const dispatch = useDispatch()
  const [code, setCode] = useState('')
  const otpState = useSelector(selectOtp)

  const loading = useSelector(selectIsLoading('change_email_otp_validation'))

  const disabled = code.length < CODE_LENGTH

  const handleSubmit = () => {
    dispatch(AccountActions.verifyOtp({ otp: code }))
  }

  const onChange = (code: string) => {
    setCode(code)

    dispatch(AccountActions.clearOtpError())
  }

  return (
    <Modal classnames={{ content: css.modal_content }} onClose={onClose}>
      <div className={css.modal_title}>Check your email</div>
      <div className={css.modal_text}>
        We’ve sent a verification code to your new email. Please check your
        inbox at <strong className={css.strong}>{otpState?.email}</strong>
      </div>

      <div className={css.modal_code}>
        <CodeInput
          code={code}
          error={Boolean(otpState?.error)}
          disabled={loading}
          onChange={onChange}
        />
      </div>

      <div className={css.modal_error}>
        <span className={css.error_message}>{otpState?.error}</span>
      </div>

      <div className={css.buttons}>
        <Button
          className={css.modal_button}
          label="Continue"
          loading={loading}
          disabled={disabled}
          onClick={handleSubmit}
        />
        <button type="button" onClick={onClose} className={css.ghost_button}>
          Cancel
        </button>
      </div>
    </Modal>
  )
}
